export default {
  activateLandingPageTitle: 'Etkinlikler',
  activateProductCardTitle: 'Etkinlikler',
  activateProductPageTitle: 'Etkinlik Rezerve Et',
  allProductsLandingPageTitle: 'E\u015fsiz Deneyimler Rezerve Et',
  apply: 'Uygula',
  buyTickets: 'Bilet sat\u0131n al',
  cancel: '\u0130ptal',
  clear: 'Temizle',
  clearFilters: 'Filtreleri temizle',
  discoverExperiences: 'Deneyimleri ke\u015ffedin',
  exclusive: '\u00d6zel',
  experience: 'deneyim',
  experiencePhotoOfListing:
    '{{listingTitle}} ilan\u0131n\u0131n {{photoNumber}}. deneyim foto\u011fraf\u0131',
  experiences: 'deneyimler',
  filterExperiences: 'Deneyimleri filtrele',
  fromListingCard: 'Ba\u015flang\u0131\u00e7',
  hostedBy: 'Sunan',
  hostLandingPageTitle: 'Yerel deneyimler',
  hostProductCardTitle: 'Yerel Deneyimler',
  hostProductPageTitle: 'Yerel Deneyimleri Rezerve Et',
  landingPageTitle: 'E\u015fsiz Deneyimler Rezerve Et',
  mainLandingPageTitle: 'T\u00fcm Deneyimler',
  more: 'Daha fazla',
  noExperiencesFound: 'Deneyim bulunamad\u0131',
  noExperiencesFoundFor: '\u015eu arama i\u00e7in deneyim bulunamad\u0131',
  experiencesFoundCount: '{{count}} deneyim bulundu',
  profileImageOfHost: '{{hostName}} ev sahibinin profil g\u00f6rseli',
  reserve: 'Rezerve Et',
  reserveLandingPageTitle: 'Aktiviteler ve olanaklar',
  reserveProductCardTitle: 'Aktiviteler',
  reserveProductPageTitle: 'Aktiviteleri ve Olanaklar\u0131 Rezerve Et',
  resultsPageTitle: 'Deneyimleri ve Aktiviteleri Rezerve Et',
};
